import Formula from '../../../HCLTreeVertexValue/Formula';
import Label from '../../../HCLTreeVertexValue/Label';
import FaultTreeTransferGateVertexValue from '../FaultTreeTransferGateVertexValue';

class FaultTreeInstanceTransferGateVertexValue extends FaultTreeTransferGateVertexValue {

  getDefaultFormula(): Formula {
    const outcomeJSON = this.getDefaultOutcomeJSON();
    //@ts-ignore
    outcomeJSON.make_instance = true;
    return new Formula(outcomeJSON);
  }

  getDefaultLabel(): Label {
    return new Label('Instance Transfer Gate', '');
  }

  clone(): FaultTreeInstanceTransferGateVertexValue {
    return new FaultTreeInstanceTransferGateVertexValue(this.label.clone(), this.formula.clone());
  }
}

export default FaultTreeInstanceTransferGateVertexValue;
